/**
 * WECHSELT DAS KONTO, DARF DIE ALTE SEITE NICHT STEHEN BLEIBEN.
 *
 * ══ DER BEFUND (Betreiber 15.10.2026) ════════════════════════════════════
 *
 * „Diesen Datensatz sollte guido@aretz.koeln nicht sehen! Man sieht ihn aber
 * unter guido@aretz.koeln." — mit Bild: der Datensatz „01 Notfall" der
 * Datenbank-Eigentümerin, offen in einem Fenster, das oben rechts
 * guido@aretz.koeln anzeigt.
 *
 * ══ WAS GEMESSEN WURDE ═══════════════════════════════════════════════════
 *
 * Der Server hat ihn NICHT ausgeliefert. Im Protokoll des dev-Servers steht
 * zur selben Zeit, mehrfach:
 *
 *   AccessDeniedException: No read permission for
 *   entryId=6ad095db0e0dbd19e73ccc8e for customerId=679f3bccdfd58424bef672a0
 *
 * und zu seinem Bild sechsmal `401`. Ein zweites, echtes Konto mit genau
 * seinen Rechten bekam über die Schnittstelle 0 fremde Datensätze. Die
 * Rechte greifen also — die Seite zeigte Inhalt, den sie VORHER hatte.
 *
 * ══ WIE ES DAZU KOMMT ════════════════════════════════════════════════════
 *
 * Die Anmeldung liegt in einem Cookie und gilt für ALLE Fenster. Der Inhalt
 * einer geöffneten Seite liegt dagegen im Arbeitsspeicher GENAU DIESES
 * Fensters. Wer sich in einem zweiten Fenster anders anmeldet, hat danach:
 *
 *   • neue Anmeldung (jede neue Anfrage läuft unter dem neuen Konto)
 *   • alten Inhalt (das erste Fenster lädt von sich aus nichts nach)
 *
 * Die Seite zeigt dann Daten des vorigen Kontos, obwohl oben das neue steht.
 * Sichtbar wird es an den Bildern: die werden frisch geholt — und bleiben
 * leer, genau wie in seinem Bild.
 *
 * DIE ENTSCHEIDUNG STEHT HIER und nicht im Plugin, damit sie prüfbar ist:
 * Eine Weiche, die nur im Browser läuft, prüft niemand.
 */

/** Die Kennung der angemeldeten Person aus der Sitzung — oder `null`. */
export const kennungDerSitzung = (sitzung: unknown): string | null => {
  const nutzer = (sitzung as any)?.user;
  if (!nutzer) return null;
  const wert = nutzer.email ?? nutzer.id ?? nutzer.name;
  return typeof wert === 'string' && wert.trim() ? wert.trim() : null;
};

/**
 * Muss die Seite neu geladen werden?
 *
 * NUR BEIM ECHTEN WECHSEL. Beim ersten Mal gibt es nichts zu vergleichen,
 * und solange die Sitzung geprüft wird (`loading`), steht noch gar nichts
 * fest — ein Neuladen in diesem Moment ergäbe eine Schleife.
 *
 * ABMELDEN IN EINEM ANDEREN FENSTER zählt mit: Danach gehört der Inhalt
 * niemandem mehr, der ihn noch sehen dürfte.
 */
export const braucheNeuladen = (
  bekannt: string | null,
  jetzt: string | null,
  stand: 'authenticated' | 'unauthenticated' | 'loading' | string,
): boolean => {
  if (stand === 'loading') return false;
  if (bekannt === null) return false;
  if (stand === 'unauthenticated') return true;
  return jetzt !== null && jetzt !== bekannt;
};
